import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import {
    AUTH_SERVICE_IMPL,
    IAuthenticationService,
} from '../services/authentication/iauthentication.service';
import { FlashMessageService } from '../modules/flash-message/flash-message.service';
import { Policy } from '../types/policy';

@Injectable({
    providedIn: 'root',
})
export class CanGuard  {
    constructor(
        @Inject(AUTH_SERVICE_IMPL) private _authService: IAuthenticationService,
        private _router: Router,
        private _flashMessageService: FlashMessageService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this._authService.currentUser;
        const policy = route.data.policy as Policy;
        if (!currentUser) {
            this._router.navigate(['/login'], {
                queryParams: { returnUrl: state.url },
            });
            return false;
        } else if (!currentUser.can(policy)) {
            this._flashMessageService.showMessage(
                'common.access_denied',
                `You're not allowed to access this route`
            );
            this._router.navigate(['']);
            return false;
        }
        return true;
    }
}
